import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiArrowRightLine } from 'react-icons/ri';
import phoneImage from '../../image/phone1.png';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section id="accueil" className="lp-hero">
      <div className="lp-hero-bg">
        <div className="lp-hero-blob lp-hero-blob-1" />
        <div className="lp-hero-blob lp-hero-blob-2" />
        <div className="lp-hero-grid" />
      </div>

      <div className="lp-hero-inner">
        <div className="lp-hero-content lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Comptabilité simplifiée pour entrepreneurs
          </div>

          <h1>
            Déposez votre facture, <span>Easy Compta</span> s&apos;occupe du
            reste
          </h1>

          <p className="lp-hero-desc">
            Photographiez ou importez une facture : montants, dates et TVA sont
            saisis pour vous. Vos écritures, soldes et rapports PDF suivent -
            sans tableur, sans jargon comptable.
          </p>

          <div className="lp-hero-cta">
            <button
              type="button"
              className="lp-btn lp-btn-primary"
              onClick={() => navigate('/signup')}
            >
              Commencer gratuitement
              <RiArrowRightLine />
            </button>
            <button
              type="button"
              className="lp-btn lp-btn-outline"
              onClick={() => navigate('/login')}
            >
              Se connecter
            </button>
          </div>

          <div className="lp-hero-trust">
            <div className="lp-hero-stat">
              <strong>30 sec</strong>
              <span>Par facture traitée</span>
            </div>
            <div className="lp-hero-stat">
              <strong>80%</strong>
              <span>De temps gagné</span>
            </div>
            <div className="lp-hero-stat">
              <strong>5</strong>
              <span>Rapports PDF en 1 clic</span>
            </div>
          </div>
        </div>

        <div className="lp-hero-visual lp-reveal lp-reveal-delay-2">
          <div className="lp-hero-phone-wrap">
            <img src={phoneImage} alt="Application Easy Compta" />
            <div className="lp-hero-float-card lp-hero-float-card-1">
              <div className="lp-float-card-label">Facture déposée</div>
              <div className="lp-float-card-value">Champs remplis ✓</div>
            </div>
            <div className="lp-hero-float-card lp-hero-float-card-2">
              <div className="lp-float-card-label">Bilan &amp; PDF</div>
              <div className="lp-float-card-value">Prêt à envoyer ✓</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
